import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesCalAdscStore', Object.keys(getters)),
	...mapState('mesCalAdscStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesCalAdscStore', Object.keys(actions)),
	...mapMutations('mesCalAdscStore', Object.keys(mutations))
};
